import React, { useEffect } from 'react';
import Header from'../Component/Header'
import { Link } from 'react-router-dom';
const Library = () => { 
    useEffect(() => {
        document.title = ' Library - Sacread Heart Kharagpur';  
    }, []); 
  return (
     <>
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                  <li>Academic</li>
                 <li>Library</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Library</h1>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12">
                         <ul className="list">
                         <li> Students should cultivate a habit of borrowing books from the library. Through these books students are able to satisfy their need for curiosity, further read on the subject they have learnt in the class, create the habit of reading etc </li> 
                         <li> When the students loose library books they are asked to either replace the same or pay the price of new book. </li>
                         <li> Rs 10/- per day is charged as fine from students who do not return the books in time. </li>
                         </ul>
                    </div>
                </div>
                 
            </div>
        </div>
     </>
  )
}

export default Library

